import { render, staticRenderFns } from "./elementChat.vue?vue&type=template&id=2863523d&scoped=true&"
import script from "./elementChat.vue?vue&type=script&lang=js&"
export * from "./elementChat.vue?vue&type=script&lang=js&"
import style0 from "./elementChat.vue?vue&type=style&index=0&id=2863523d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2863523d",
  null
  
)

export default component.exports